import { getLocaleStore } from '@/i18n';
import { RecognizeTarget } from './types';

// 面板默认配置
export const DefaultEliminatePenSize = 25;

export const GLPreviewId = `GLContainer-preview`;
/**
 * 画笔类型
 */
export const DrawPenDataType = 'draw-pen';

// 错误提示语
export const getFailedText = (target: RecognizeTarget) => {
    const { $t } = getLocaleStore();

    if (target === 'text') {
        return $t((v) => v.mainLayer.operate.textEmptyAreaTips);
    } else if (target === 'watermark') {
        return $t((v) => v.mainLayer.operate.watermarkEmptyAreaTips);
    } else if (target === 'passerby') {
        return $t((v) => v.mainLayer.operate.passerbyEmptyAreaTips);
    } else if (target === 'glasses') {
        return $t((v) => v.mainLayer.operate.glassesEmptyAreaTips);
    } else {
        return $t((v) => v.mainLayer.operate.emptyAreaTips);
    }
};
